module.exports = __webpack_public_path__ + "img/user.32eda1c7.svg";